module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('br')]), _vm._v(" "), _c('p', [_c('br')]), _vm._v(" "), _c('h1', {
    staticClass: "sigil_not_in_toc"
  }, [_c('i', [_vm._v("Section 1")])]), _vm._v(" "), _c('h2', {
    staticClass: "sec-head",
    attrs: {
      "id": "sigil_toc_id_11",
      "title": "Section 1: Tools for Loving People with Addiction"
    }
  }, [_vm._v("Tools for Loving"), _c('br'), _vm._v("\n  People with Addiction")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "chding"
  }, [_c('img', {
    attrs: {
      "alt": "cross",
      "src": "Images/4125_graphic_C.png",
      "width": "3%"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ceb800","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/sec1.vue
// module id = 72
// module chunks = 0